import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import { store } from './store'
import vuetify from './plugins/vuetify';
import userCache from '@/mixins/UserDataCache'
import common from '@/mixins/Common'
import operationLogger from '@/mixins/OperationLogger'
import groupUserAuthorityChacker from '@/mixins/GroupUserAuthorityChecker'
import VueMermaid from 'vue-mermaid'
import JsonTree from "vue-json-tree-view"

Vue.mixin(common)
Vue.mixin(userCache)
Vue.mixin(operationLogger)
Vue.mixin(groupUserAuthorityChacker)

Vue.use(VueMermaid)
Vue.use(JsonTree)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
